// extracted by mini-css-extract-plugin
module.exports = {"invalidPositionsNotice":"TransitionProposalDetails-module__invalidPositionsNotice--11c7H"};